<div class="limits-progress-item">
  <div class="limits-progress-item-label">{{ limitItem.label }}</div>

  @if (isSingle) {
    <div class="limits-progress-item-single-amount">
      {{ limitItem.amount | amount: limitItem.currency }}
    </div>
  }

  @if (!isSingle) {
    <div class="limits-progress-item-amount">
      <div class="limits-progress-item-progress">
        <div class="progress-bar">
          <div class="progress-bar-inner" [ngStyle]="{ width: limitItem.progress > 100 ? 100 : limitItem.progress + '%' }"></div>
        </div>
      </div>
      <div class="limits-progress-item-values">
        <div class="limit-amounts">
          <span class="limit-amounts-spent"> {{ limitItem.usedAmount | amount: limitItem.currency }} spent </span>
          of {{ limitItem.amount | amount: limitItem.currency }}
        </div>
        <div class="limits-progress-item-used-amount">
          @if (limitItem.progress > 0 && limitItem.progress < 1) {
            <span><1</span>
          } @else {
            {{ limitItem.progress | number: '1.0-1' }}
          }
          %
        </div>
      </div>
    </div>
  }
</div>
